export default __webpack_public_path__ + "static/media/women.353c4f55.png";